module.exports = __webpack_public_path__ + "img/svg_bg.59f19528.svg";